import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import get from "lodash/get";
import { getRequest } from './api-client';
import { LoadMoreStoriesManager } from './impl/load-more-stories-manager';
/**
 * This component is very similar to the {@link LoadMoreBase} component but fetches the stories from a `collection`. The api call `/api/v1/collections/{collectionSlug}` is made with the passed collection slug value. The component accepts the `params` prop and a requires a Collection Slug from which to fetch the stories and returns a set of stories only.
 *
 * ```javascript
 * import { LoadMoreCollectionStories } from '@quintype/components';
 *
 * function MoreCollectionStories({collection, stories, loading, onLoadMore, noMoreStories}) {
 *   return <div/>;
 * }
 *
 * export function HomePage(props) {
 *   return <LoadMoreCollectionStories template={MoreCollectionStories}
 *                                     collectionSlug={props.data.collectionSlug}
 *                                     data={{collection: collection, stories: initialStories}}
 *                                     params={{}}/>
 * }
 * ```
 *
 * ### Get Collection of stories written by a particular author
 * We can get the collection of stories written by a specific author by using the authorId prop as below:
 * ```javascript
 * export function HomePage(props) {
 *   return <LoadMoreCollectionStories
 *             template={MoreCollectionStories}
 *             data={{stories: stories}}
 *             authorId={props.author.id}
 *             params={{}}
 *             numStoriesToLoad={10} />
 * }
 * ```
 *
 * Also see {@link LoadMoreStoriesBase} for a version that takes a section id instead of a collection
 * @component
 * @category Collection Page
 */

export var LoadMoreCollectionStories = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadMoreCollectionStories, _React$Component);

  var _super = /*#__PURE__*/_createSuper(LoadMoreCollectionStories);

  function LoadMoreCollectionStories() {
    _classCallCheck(this, LoadMoreCollectionStories);

    return _super.apply(this, arguments);
  }

  _createClass(LoadMoreCollectionStories, [{
    key: "loadMoreStories",
    value: function loadMoreStories(pageNumber) {
      var stories = get(this.props, ['data', 'stories'], []);
      var authorId = get(this.props, ["authorId"], null);
      var url = authorId ? "/api/v1/authors/".concat(authorId, "/collection") : "/api/v1/collections/".concat(this.props.collectionSlug);
      return getRequest(url, Object.assign({}, this.props.params, {
        offset: this.props.numStoriesToLoad * (pageNumber - 1) + stories.length,
        limit: this.props.numStoriesToLoad || 10
      })).json(function (response) {
        return (response.items || []).map(function (item) {
          return item.story;
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(LoadMoreStoriesManager, Object.assign({}, this.props.data, {
        template: this.props.template,
        loadStories: function loadStories(pageNumber) {
          return _this.loadMoreStories(pageNumber);
        },
        languageDirection: this.props.languageDirection,
        numStoriesToLoad: this.props.numStoriesToLoad || 10
      }));
    }
  }]);

  return LoadMoreCollectionStories;
}(React.Component);